<template>
  <div v-if="patientReady" v-cloak>
    <div class="dropdown top-right">
      <button type="button" class="btn btn-primary dropdown-toggle"
        data-toggle="dropdown" :disabled="patient.screeningStatus !== 5">
        Indexhantering
      </button>
      <div class="dropdown-menu margin-right-vw">
        <a class="dropdown-item" @click="inviteIdx()" :disabled="patient.doNotWantToBecomeIndexPatient">Bjuda in som index</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" @click="discloseIdx()">Vill ej ingå som index</a>
        <a class="dropdown-item" @click="endPatientParticipation()">Vill avsluta sin delaktighet</a>
      </div>
    </div>
    <div class="container bg--gen-negative">
      <h5 class="text-muted margin-left-vw">Person-ID: {{ patient.personId }}</h5>
      <h2 class="text-muted margin-left-vw">{{ patient.firstName + ' ' + patient.lastName }}</h2>
      <p>
        <span class="text-muted margin-left-vw" v-text="formatPnr(patient.ssn)"></span>
        <span class="text-muted">({{ getAge }} år)</span>
        <span class="text-muted">({{ getGender }})</span>
      </p>
      <p class="text-muted margin-left-vw">
        <strong>Patientflöde</strong>:
        {{ ($options.name && $options.name.includes('negative') ? 'Gen negativ' : 'Gen positiv') }}
      </p>
      <p class="text-muted margin-left-vw">
        <strong>Status</strong>: {{ getStatus(patient.screeningStatus) }}
      </p>
      <p v-if="patient.doNotWantToBecomeIndexPatient" class="text-muted margin-left-vw">
        <strong>Vill inte bli inbjuden som index</strong>
      </p>
      <p class="text-muted margin-left-vw">
        <strong>Indexpatient</strong>:
        <router-link :to="'/indexpatient_gen_negative/' + patient.indexPatientId">
          {{ patient.indexPatientName }} (Index-ID: {{ patient.indexPatientId }})
        </router-link>
      </p>
      <div class="row right">
        <div class="col col-lg col-mr-60">
          <strong>Kontakt</strong>
          <p v-if="patient">
            <i v-if="patient.phoneNumber && !patient.phoneNumber.startsWith('0')">+46</i>{{ patient.phoneNumber || '-' }} <br />
            {{ patient.emailAddress || '-' }}
          </p>
        </div>
        <div class="col col-lg col-mr-60">
          <strong>Folkbokförd</strong>
          <p v-if="populationInfo">
            {{ populationInfo.streetAddress || '-' }} <br />
            {{ populationInfo.postalCode || '-' }} <br />
            {{ populationInfo.city || '-' }}
          </p>
          <div v-if="!populationInfo" class="div-loader">Hämtar</div>
          <p v-if="!hasPopulationInfo">
            Kunde inte hämta från NAVET. <span class="text-primary cursor-pointer" @click="getFromNavet()">Hämta igen</span>
          </p>
        </div>
        <div class="col col-lg col-mr-60">
          <strong>Registrerad av:</strong>
          <p>{{ patient.clinicianName || '-' }}</p>
        </div>
      </div>
      <div class="clearfix"></div>
      <nav class="navbar navbar-expand-sm bg-light">
        <!-- Links -->
        <ul class="navbar-nav">
          <li class="nav-item active_btm">
            <a class="nav-link text-primary" href="#">Diagnosunderlag</a>
          </li>
          <!-- <li class="nav-item" :class="{ active_btm: setActive(2)}">
            <a class="nav-link text-primary" href="#">Lägg in provsvar</a>
          </li> -->
        </ul>
      </nav>
      <div class="wrapper">
        <!-- GET /screeninganswer -->
        <div class="card card-screening journal-card light-red">
          <div class="card-body">
            <p class="text-dark pull-left"><strong>Screeningfrågor/svar</strong></p>
            <div class="row">
              <div class="col-lg-7 text-muted">
                <p><u>Fråga</u></p>
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiagnosis'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningdiagnosis')).question }}
                </span>
                <span v-else>Fråga om diagnos ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningmutation'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningmutation')).question }}
                </span>
                <span v-else>Fråga om mutation ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeninggentest'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeninggentest')).question }}
                </span>
                <span v-else>Fråga om gentest ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningmedicine'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningmedicine')).question }}
                </span>
                <span v-else>Fråga om medicinering ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningvegan'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningvegan')).question }}
                </span>
                <span v-else>Fråga om vegansk kost ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiet'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningdiet')).question }}
                </span>
                <span v-else>Fråga om diet ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningegg'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningegg')).question }}
                </span>
                <span v-else>Fråga om äggintag ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningsmoking_web'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningsmoking_web')).question }}
                </span>
                <span v-else>Fråga om rökning ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeninghypertension_web'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeninghypertension_web')).question }}
                </span>
                <span v-else>Fråga om hypertoni ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiabetestype1_web'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningdiabetestype1_web')).question }}
                </span>
                <span v-else>Fråga om diabetes typ 1 ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiabetestype2_web'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningdiabetestype2_web')).question }}
                </span>
                <span v-else>Fråga om diabetes typ 2 ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningarteriosclerosis_web'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningarteriosclerosis_web')).question }}
                </span>
                <span v-else>Fråga om hjärtinfarkt/åderförkalkning ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningstroke_web'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningstroke_web')).question }}
                </span>
                <span v-else>Fråga om stroke ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningpeephole_web'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningpeephole_web')).question }}
                </span>
                <span v-else>Fråga om periferkärlsjukdom/claudicatio/fönstertittarsjuka ej tillgänglig</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('consentjournals'))">
                  {{ consentJournalsText }}
                </span>
                <span v-else>Fråga om journaldelning ej tillgänglig</span>
              </div>
              <div class="col-lg-4 text-muted">
                <p><u>Svar</u></p>
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiagnosis'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningdiagnosis')).answer }}
                  <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiagnosis')).diagnosisyear &&
                    getSpecificScreeningAnswer(getFieldId('screeningdiagnosis')).diagnosisyear !== 'Vet ej'">
                    (Diagnosår: {{ getSpecificScreeningAnswer(getFieldId('screeningdiagnosis')).diagnosisyear }})
                  </span>
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningmutation'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningmutation')).answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeninggentest'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeninggentest')).answer }}
                  <span v-if="getSpecificScreeningAnswer(getFieldId('screeninggentest')).facility &&
                    getSpecificScreeningAnswer(getFieldId('screeninggentest')).facility !== 'Vet ej'">
                    ({{ getSpecificScreeningAnswer(getFieldId('screeninggentest')).facility }})
                  </span>
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningmedicine'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningmedicine')).answer }}
                  <small class="text-muted cursor-pointer"
                    data-toggle="modal" data-target="#medicineModal" data-backdrop="keyboard"
                    v-if="getSpecificScreeningAnswer(getFieldId('screeningmedicine')).answer === 'Ja'">
                    [Visa läkemedel]
                  </small>
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningvegan'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningvegan')).answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiet'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningdiet')).answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningegg'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningegg')).eggs.answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningsmoking_web'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningsmoking_web')).answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeninghypertension_web'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeninghypertension_web')).answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiabetestype1_web'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningdiabetestype1_web')).answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningdiabetestype2_web'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningdiabetestype2_web')).answer }}
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningarteriosclerosis_web'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningarteriosclerosis_web')).answer }}
                  <span v-if="getSpecificScreeningAnswer(getFieldId('screeningarteriosclerosis_web')).age">
                    (Ålder: {{ getSpecificScreeningAnswer(getFieldId('screeningarteriosclerosis_web')).age }})
                  </span>
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningstroke_web'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningstroke_web')).answer }}
                  <span v-if="getSpecificScreeningAnswer(getFieldId('screeningstroke_web')).age">
                    (Ålder: {{ getSpecificScreeningAnswer(getFieldId('screeningstroke_web')).age }})
                  </span>
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('screeningpeephole_web'))">
                  {{ getSpecificScreeningAnswer(getFieldId('screeningpeephole_web')).answer }}
                  <span v-if="getSpecificScreeningAnswer(getFieldId('screeningpeephole_web')).age">
                    (Ålder: {{ getSpecificScreeningAnswer(getFieldId('screeningpeephole_web')).age }})
                  </span>
                </span>
                <span v-else>-</span>
                <hr />
                <span v-if="getSpecificScreeningAnswer(getFieldId('consentjournals'))">
                  {{ getSpecificScreeningAnswer(getFieldId('consentjournals')).answer }}
                  <span v-if="getSpecificScreeningAnswer(getFieldId('consentjournals')).carefacility">
                    ({{ getSpecificScreeningAnswer(getFieldId('consentjournals')).carefacility }})
                  </span>
                </span>
                <span v-else>-</span>
                <div v-if="getSpecificScreeningAnswer(getFieldId('screeningmedicine'))"
                  class="modal" id="medicineModal" aria-labelledby="medicineModal" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <h5 class="modal-title" id="exampleModalLabel">Läkemedel</h5>
                      <button type="button" class="close pull-right" data-dismiss="modal">&times;</button>
                      <div class="modal-body">
                        <div v-for="(d, i) in getSpecificScreeningAnswer(getFieldId('screeningmedicine')).drugs" :key="i">
                          <table class="table" v-if="d.dose !== 0 && d.unit !== 0 && d.amountperday !== 0">
                            <tr>
                              <th>Namn</th>
                              <th>Dos</th>
                              <th>Enhet</th>
                              <th>Frekvens</th>
                            </tr>
                            <tr>
                              <td>{{ toTitleCase(d.name) || toTitleCase(d.value) }}</td>
                              <td>{{ d.dose }}</td>
                              <td>{{ d.unit }}</td>
                              <td>{{ d.amountperday || d.injectionsperweek }}</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <!-- GET /referral/createpaperreferral -->
        <!-- POST /bloodtest för 'Lägg till provsvar' -->
        <!-- DELETE /referral/createpaperreferral för checkbox -->
        <div class="card journal-card">
          <div class="card-body">
            <p class="text-dark pull-left"><strong>Labbremiss papper</strong></p>
            <div class="row">
              <div class="col-sm-4">
                <p><u>Pappersremiss</u></p>
                <p v-if="paperReferral">
                  Om värden är ifyllda så visas dem
                  <span class="text-primary cursor-pointer" @click="goToBloodAssessmentCard()">
                    <b>här</b>
                  </span>
                </p>
                <p v-if="!paperReferral">Ingen pappersremiss tillgänglig/skapad</p>
              </div>
              <div class="col-sm-4">
                Remiss skapad och skickad &nbsp;
                <input type="checkbox" @change="paperReferralStateChange($event)" :checked="paperReferral">
              </div>
              <div class="col-sm-3">
                <button class="btn btn-primary btn-block" @click="showAddAndScroll()" :disabled="!paperReferral">
                  Lägg till provsvar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <!-- GET /bloodtestassessment - bloodTest -->
        <div class="card journal-card light-yellow" id="bloodtestassessment-card">
          <div class="card-body" v-if="!bloodtest">
            <div class="clearfix"></div>
            <p class="pull-left" v-if="!bloodtest">Inga provsvar inlagda</p>
          </div>
          <div class="card-body" v-if="bloodtest">
            <div class="row">
              <div class="col-sm-6">
                <table class="table table-bordered bg-white" v-if="bloodtest">
                  <thead>
                    <tr>
                      <th>
                        <strong>Enligt journaluppgifter högsta uppmätta obehandlade LDL-kolesterol</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ bloodtest.ldlHighestMeasured || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <p class="text-dark pull-left">
              <strong>Senaste resultatet för blodfetter</strong>
            </p>
            <div class="row">
              <div class="col-sm">
                <p class="text-dark pull-left" v-if="bloodtest">
                  Provtagningsdatum: {{ new Date(bloodtest.testDate).toLocaleDateString() }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <table class="table table-bordered bg-white" v-if="bloodtest">
                  <thead>
                    <tr>
                      <th><strong>LDL värde från Friedewalds</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ bloodtest.ldlFriedewalds || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-sm-1">
                <span class="filter icon cursor-pointer"
                  v-if="bloodtest" v-popover:tooltip.top="'LDL kolesterol beräknat enligt Friedewalds formel'">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
              </div>
              <div class="col-sm-4">
                <table class="table table-bordered bg-white" v-if="bloodtest">
                  <thead>
                    <tr>
                      <th><strong>Beräknat obehandlat LDL kolesterol</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ bloodtest.ldlUntreated || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-sm-1">
                <span class="filter icon cursor-pointer"
                  v-if="bloodtest" v-popover:tooltip.top="'Framräknat obehandlat LDL kolesterol baserat på aktuell behandling'">
                  <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                </span>
              </div>
            </div>
            <p class="text-dark pull-left"><strong>Labprovsvar</strong></p>
            <p class="text-dark pull-right cursor-pointer"
            @click="showAndScroll()"
            :class="(!bloodtest || bloodtest.isReadOnly) ? 'disable-edit': ''"
            >✏️ Redigera</p>
            <div class="row">
              <div class="col-sm-9">
                <table class="table table-bordered bg-white" v-if="bloodtest">
                  <thead>
                    <tr>
                      <th>Typ</th>
                      <th>Värde</th>
                      <th>Referensintervall</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>LDL</td>
                      <td v-if="!bloodtest.ldlUncalculated">-</td>
                      <td v-if="bloodtest.ldlUncalculated">
                        {{ bloodtest.ldlUncalculated }} {{ bloodtest.ldlUnit }}
                      </td>
                      <td>{{ bloodtest.ldlReferenceInterval || '-' }}</td>
                    </tr>
                    <tr>
                      <td>HDL</td>
                      <td>{{ bloodtest.hdl }} {{ bloodtest.hdlUnit }}</td>
                      <td>{{ bloodtest.hdlReferenceInterval || '-' }}</td>
                    </tr>
                    <tr>
                      <td>Triglycerider</td>
                      <td>{{ bloodtest.triglycerider }} {{ bloodtest.triglyceriderUnit }}</td>
                      <td>{{ bloodtest.triglyceriderReferenceInterval || '-' }}</td>
                    </tr>
                    <tr>
                      <td>Totalkolesterol</td>
                      <td>{{ bloodtest.totalKolesterol }} {{ bloodtest.totalKolesterolUnit }}</td>
                      <td>{{ bloodtest.totalKolesterolReferenceInterval || '-' }}</td>
                    </tr>
                    <tr>
                      <td>Lipoprotein (a)</td>
                      <td>{{ bloodtest.lipoProteinA }} {{ bloodtest.lipoProteinAUnit }}</td>
                      <td>-</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-sm-2">
                <p class="text-dark pull-left"><strong>Referensskalor</strong></p>
                <div class="input-group mb-3">
                  <button class="btn btn-primary btn-sm min-w-275" data-toggle="modal"
                    data-target="#refScaleFemale">Kvinna</button>
                </div>
                <div class="input-group mb-3">
                  <button class="btn btn-primary btn-sm min-w-275" data-toggle="modal"
                    data-target="#refScaleMale">Man</button>
                </div>
                <div class="input-group mb-3">
                  <button class="btn btn-primary btn-sm min-w-275" data-toggle="modal"
                    data-target="#refScaleChild">Barn (0-18 år)</button>
                </div>
                <!-- Referensskala kvinna -->
                <div class="modal" id="refScaleFemale" aria-labelledby="refScaleFemale" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered">
                    <img src="@/assets/img/reference_scale_female.png" alt="Referensskala för kvinna"
                      class="img-fluid img--zoom" />
                  </div>
                </div>
                <!-- Referenskala man -->
                <div class="modal" id="refScaleMale" aria-labelledby="refScaleMale" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered">
                    <img src="@/assets/img/reference_scale_male.png" alt="Referensskala för man"
                      class="img-fluid img--zoom" />
                  </div>
                </div>
                <!-- Referenskala barn -->
                <div class="modal" id="refScaleChild" aria-labelledby="refScaleChild" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="p-3 mb-2 bg-light text-dark">
                      <h2>Bild med referensskala för barn finns ej tillgänglig ännu</h2>
                      </div>
                    <!-- <img src="@/assets/img/reference_scale_child.png" alt="Referensskala för barn (0-18 år)" class="img-fluid img--zoom" /> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <!-- Lägga till provsvar samt referensintervaller -->
        <div id="edittestresults" class="card journal-card" v-if="intervalLists && showEditTestResults">
          <span class="top-right-close" aria-hidden="true" @click="showEditTestResults = false">&times;</span>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-5">
                <p class="text-dark pull-left">
                  <strong>Enligt journaluppgifter högsta uppmätta obehandlade LDL kolesterolvärde</strong>
                </p>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">LDL</span>
                  </div>
                  <input type="text" class="form-control" v-model="bloodtest_temp_edit.ldlHighestMeasured">
                </div>
              </div>
              <div class="col-sm-2">
                <p class="text-dark pull-left"><strong>Enhet</strong></p>
                <div class="input-group mb-3">
                  <input type="text" class="form-control" v-model="bloodtest_temp_edit.ldlUnit" disabled>
                </div>
              </div>
              <div class="col-sm-5">
                <p class="text-dark pull-left"><strong>Referensintervall</strong></p>
                <div class="input-group mb-3">
                    <select class="form-control" v-model="bloodtest_temp_edit.ldlReferenceInterval">
                      <option :value="''">Välj intervall för LDL</option>
                      <option
                        v-for="(ldl, i) in intervalLists.clinicMisc.ldlRefList"
                        v-html="ldl"
                        :key="i"
                        :title="toElementTitle(ldl)">
                      </option>
                    </select>
                </div>
              </div>
            </div>
            <hr />
            <p class="text-dark pull-left" id="edit-testresults">
              <strong style="display: none">Ange senaste resultatet för blodfetter</strong>
            </p>
            <div class="row">
              <div class="col-sm">
                <p class="text-dark pull-left"><strong>Provsvarsresultat</strong></p>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Provdatum</span>
                  </div>
                  <date-pick v-model="bloodtest_temp_edit.testDate" :displayFormat="'YYYY-MM-DD'"
                  :inputAttributes="{name: bloodtest_temp_edit.testDate, id: 'bloodTestDate', class: ['form-control'],
                    readonly: true, placeholder: 'Välj provdatum'}">
                  </date-pick>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <p class="text-dark pull-left"><strong>Provsvarsresultat</strong></p>
                <div class="input-group mb-3">
                  <span class="filter icon cursor-pointer"
                    v-if="bloodtest_temp_edit.triglycerider && bloodtest_temp_edit.triglycerider.replace(/,/g, '.') >= 4.5"
                      v-popover:tooltip.top="data.clinicInfoIcon.triglyceridesTooHigh">
                    <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                  </span>
                  <div class="input-group-prepend">
                    <span class="input-group-text">Triglycerider</span>
                  </div>
                  <input type="text" class="form-control" v-model="bloodtest_temp_edit.triglycerider">
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Totalkolesterol</span>
                  </div>
                  <input type="text" class="form-control" v-model="bloodtest_temp_edit.totalKolesterol">
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">HDL</span>
                  </div>
                  <input type="text" class="form-control" v-model="bloodtest_temp_edit.hdl">
                </div>
                <label class="left">Beräknad LDL värde från Friedewalds (om TG&#60;4,5mmol/L)</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">LDL</span>
                  </div>
                  <input type="text" class="form-control"
                    v-model="bloodtest_temp_edit.ldlFriedewalds"
                    :class="(bloodtest_temp_edit.triglycerider && bloodtest_temp_edit.triglycerider.replace(/,/g, '.') >= 4.5) ? 'disable-edit': ''"
                    disabled>
                </div>
                <label class="left">LDL värde från direktmätningsmetod (om TG&#62;4,5mmol/L)</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">LDL</span>
                  </div>
                  <input type="text" class="form-control" v-model="bloodtest_temp_edit.ldlUncalculated"
                  :class="(bloodtest_temp_edit.ldlFriedewalds && bloodtest_temp_edit.ldlFriedewalds.length > 0) ? 'disable-edit': ''">
                </div>
                <label class="left">Senaste uppmätta Lipoprotein (a) värdet</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Lipoprotein (a)</span>
                  </div>
                  <input type="text" class="form-control" v-model="bloodtest_temp_edit.lipoProteinA">
                </div>
              </div>
              <div class="col-sm-2">
                <p class="text-dark pull-left"><strong>Enhet</strong></p>
                <div class="input-group mb-3">
                  <input type="text" class="form-control" v-model="bloodtest_temp_edit.triglyceriderUnit" disabled>
                </div>
                <div class="input-group mb-3">
                  <input type="text" class="form-control" v-model="bloodtest_temp_edit.totalKolesterolUnit" disabled>
                </div>
                <div class="input-group mb-3">
                  <input type="text" class="form-control" v-model="bloodtest_temp_edit.hdlUnit" disabled>
                </div>
                <div class="input-group mb-1">&nbsp;</div>
                <div class="input-group mb-3">
                  <input type="text" class="form-control" v-model="bloodtest_temp_edit.ldlUnit" disabled>
                </div>
                <div class="input-group mb-2">&nbsp;</div>
                <div class="input-group mb-3">
                  <input type="text" class="form-control" v-model="bloodtest_temp_edit.ldlUnit" disabled>
                </div>
                <div class="input-group mb-1">&nbsp;</div>
                <div class="input-group mb-3">
                  <select class="form-control" v-model="bloodtest_temp_edit.lipoProteinAUnit">
                    <option :value="''">Enhet för Lipoprotein (a)</option>
                    <option
                      v-for="(unit, i) in intervalLists.clinicMisc.lipoproteinRefList"
                      v-html="unit"
                      :key="i"
                      :title="toElementTitle(unit)">
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-4">
                <p class="text-dark pull-left"><strong>Referensintervall</strong></p>
                <div class="input-group mb-3">
                    <select class="form-control" v-model="bloodtest_temp_edit.triglyceriderReferenceInterval">
                      <option :value="''">Välj intervall för Triglycerider</option>
                      <option
                        v-for="(t, i) in intervalLists.clinicMisc.triglyceriderRefList"
                        v-html="t"
                        :key="i"
                        :title="toElementTitle(t)">
                      </option>
                    </select>
                </div>
                <div class="input-group mb-3">
                    <select class="form-control" v-model="bloodtest_temp_edit.totalKolesterolReferenceInterval">
                      <option :value="''">Välj intervall för Totalkolesterol</option>
                      <option
                        v-for="(tk, i) in intervalLists.clinicMisc.totalkolesterolRefList"
                        v-html="tk"
                        :key="i"
                        :title="toElementTitle(tk)">
                      </option>
                    </select>
                </div>
                <div class="input-group mb-3">
                    <select class="form-control" v-model="bloodtest_temp_edit.hdlReferenceInterval">
                      <option :value="''">Välj intervall för HDL</option>
                      <option
                        v-for="(hdl, i) in intervalLists.clinicMisc.hdlRefList"
                        v-html="hdl"
                        :key="i"
                        :title="toElementTitle(hdl)">
                      </option>
                    </select>
                </div>
                <div class="input-group mb-1">&nbsp;</div>
                <div class="input-group mb-3">
                    <select class="form-control" v-model="bloodtest_temp_edit.ldlReferenceInterval">
                      <option :value="''">Välj intervall för LDL</option>
                      <option
                        v-for="(ldl, i) in intervalLists.clinicMisc.ldlRefList"
                        v-html="ldl"
                        :key="i"
                        :title="toElementTitle(ldl)">
                      </option>
                    </select>
                </div>
                <div class="input-group mb-2">&nbsp;</div>
                <div class="input-group mb-3">
                    <select class="form-control" v-model="bloodtest_temp_edit.ldlReferenceInterval">
                      <option :value="''">Välj intervall för LDL</option>
                      <option
                        v-for="(ldl, i) in intervalLists.clinicMisc.ldlRefList"
                        v-html="ldl"
                        :key="i"
                        :title="toElementTitle(ldl)">
                      </option>
                    </select>
                </div>
              </div>
            </div>
          </div>
          <div class="card journal-card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-7">
                  <div class="form-group">
                    <label v-html="data.clinicCardio.medicineHeaderCardio"></label>
                    <div v-for="(fhDrug, grouping) in fhDrugsArray" :key="grouping">
                      <p class="text-dark pull-left">
                        <strong>{{ fhDrug.grouping }}</strong>
                      </p>
                      <select class="form-control" v-model="fhDrug.value.selectedDrug" @change="fhDrug.value.selectedDosage = ''"
                      :disabled="noDrugs">
                        <option :value="''">Välj läkemedel</option>
                        <option
                          v-for="(drug, i) in fhDrug.value.drugsInGroup"
                          v-html="drug.drug"
                          :value="drug"
                          :key="i"
                          :title="toElementTitle(drug.drug)">
                        </option>
                      </select>
                      <select class="form-control" v-model="fhDrug.value.selectedDosage"
                      :disabled="fhDrug.value.selectedDrug == ''">
                        <option :value="''">Välj enhet</option>
                        <option
                            v-for="(dosages, i) in fhDrug.value.selectedDrug.dosages"
                          v-html="dosages.doseAmount + ' ' + dosages.doseUnit"
                          :value="dosages"
                          :key="i"
                          :title="toElementTitle(dosages.doseAmount + ' ' + dosages.doseUnit)">
                        </option>
                      </select>
                      <p class="text-dark pull-left" v-if="fhDrug.value.selectedDrug.frequency === 'day'">
                        <strong>Enhet avser en tablett per dag</strong>
                      </p>
                      <p class="text-dark pull-left" v-if="fhDrug.value.selectedDrug.frequency === 'byWeekly'">
                        <strong>Enhet avser en injection enligt fast dosinterval</strong>
                      </p>
                      <div class="clearfix"></div>
                    </div>
                    <label for="nodrugs">Patienten tar inga läkemedel:</label> &nbsp;
                    <input type="checkbox" @change="resetFhDrugs()" v-model="noDrugs" id="nodrugs">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-5">
                  <label class="left">Beräknad obehandlat LDL värde</label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">LDL</span>
                    </div>
                    <input type="text" class="form-control"
                      v-model="bloodtest_temp_edit.ldlUntreated" disabled>
                  </div>
                </div>
                <div class="col-sm-2">
                  <label class="left">&nbsp;</label>
                  <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="bloodtest_temp_edit.ldlUnit" disabled>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3">
                  <button class="btn btn-primary btn-block" @click="sendUpdatedTestResults()"
                    :disabled="!bloodtest_temp_edit.testDate">Uppdatera provsvar</button>
                </div>
                <div class="col-sm"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-success alert-bloodtest-edit">
          <strong>Provsvar är tillagt samt sparat.</strong>
        </div>
        <div class="clearfix"></div>
        <!-- Lägga till provsvar samt referensintervaller -->
        <div id="addtestresults" class="card journal-card" v-if="intervalLists && showAddTestResults">
          <span class="top-right-close" aria-hidden="true" @click="showAddTestResults = false">&times;</span>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-5">
                <p class="text-dark pull-left"><strong>Enligt journaluppgifter högsta uppmätta obehandlade LDL kolesterolvärde</strong></p>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">LDL</span>
                  </div>
                  <input type="text" class="form-control" v-model="bloodtest_temp_add.ldlHighestMeasured">
                </div>
              </div>
              <div class="col-sm-2">
                <p class="text-dark pull-left"><strong>Enhet</strong></p>
                <div class="input-group mb-3">
                  <input type="text" class="form-control" v-model="bloodtest_temp_add.ldlUnit" disabled>
                </div>
              </div>
              <div class="col-sm-5">
                <p class="text-dark pull-left"><strong>Referensintervall</strong></p>
                <div class="input-group mb-3">
                    <select class="form-control" v-model="bloodtest_temp_add.ldlReferenceInterval">
                      <option :value="''">Välj intervall för LDL</option>
                      <option
                        v-for="(ldl, i) in intervalLists.clinicMisc.ldlRefList"
                        v-html="ldl"
                        :key="i"
                        :title="toElementTitle(ldl)">
                      </option>
                    </select>
                </div>
              </div>
            </div>
            <hr />
            <p class="text-dark pull-left" id="add-testresults">
              <strong style="display: none">Ange senaste resultatet för blodfetter</strong>
            </p>
            <div class="row">
              <div class="col-sm">
                <p class="text-dark pull-left"><strong>Provdatum</strong></p>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Provdatum</span>
                  </div>
                  <date-pick v-model="bloodtest_temp_add.testDate" :displayFormat="'YYYY-MM-DD'"
                  :inputAttributes="{name: bloodtest_temp_add.testDate, id: 'bloodTestDate', class: ['form-control'],
                    readonly: true, placeholder: 'Välj provdatum'}">
                  </date-pick>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <p class="text-dark pull-left"><strong>Provsvarsresultat</strong></p>
                <div class="input-group mb-3">
                  <span class="filter icon cursor-pointer"
                    v-if="bloodtest_temp_add.triglycerider && bloodtest_temp_add.triglycerider.replace(/,/g, '.') >= 4.5"
                      v-popover:tooltip.top="data.clinicInfoIcon.triglyceridesTooHigh">
                    <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
                  </span>
                  <div class="input-group-prepend">
                    <span class="input-group-text">Triglycerider</span>
                  </div>
                  <input type="text" class="form-control" v-model="bloodtest_temp_add.triglycerider">
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Totalkolesterol</span>
                  </div>
                  <input type="text" class="form-control" v-model="bloodtest_temp_add.totalKolesterol">
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">HDL</span>
                  </div>
                  <input type="text" class="form-control" v-model="bloodtest_temp_add.hdl">
                </div>
                <label class="left">Beräknad LDL värde från Friedewalds (om TG&#60;4,5mmol/L)</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">LDL</span>
                  </div>
                  <input type="text" class="form-control"
                    v-model="bloodtest_temp_add.ldlFriedewalds"
                    :class="(bloodtest_temp_add.triglycerider && bloodtest_temp_add.triglycerider.replace(/,/g, '.') >= 4.5) ? 'disable-edit': ''"
                    disabled>
                </div>
                <label class="left">LDL värde från direktmätningsmetod (om TG&#62;4,5mmol/L)</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">LDL</span>
                  </div>
                  <input type="text" class="form-control" v-model="bloodtest_temp_add.ldlUncalculated"
                  :disabled="bloodtest_temp_add.ldlFriedewalds.length > 0"
                  :class="bloodtest_temp_add.ldlFriedewalds.length > 0 ? 'disable-edit': ''">
                </div>
                <label class="left">Senaste uppmätta Lipoprotein (a) värdet</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Lipoprotein (a)</span>
                  </div>
                  <input type="text" class="form-control" v-model="bloodtest_temp_add.lipoProteinA">
                </div>
              </div>
              <div class="col-sm-2">
                <p class="text-dark pull-left"><strong>Enhet</strong></p>
                <div class="input-group mb-3">
                  <input type="text" class="form-control" v-model="bloodtest_temp_add.triglyceriderUnit" disabled>
                </div>
                <div class="input-group mb-3">
                  <input type="text" class="form-control" v-model="bloodtest_temp_add.totalKolesterolUnit" disabled>
                </div>
                <div class="input-group mb-3">
                  <input type="text" class="form-control" v-model="bloodtest_temp_add.hdlUnit" disabled>
                </div>
                <div class="input-group mb-1">&nbsp;</div>
                <div class="input-group mb-3">
                  <input type="text" class="form-control" v-model="bloodtest_temp_add.ldlUnit" disabled>
                </div>
                <div class="input-group mb-2">&nbsp;</div>
                <div class="input-group mb-3">
                  <input type="text" class="form-control" v-model="bloodtest_temp_add.ldlUnit" disabled>
                </div>
                <div class="input-group mb-1">&nbsp;</div>
                <div class="input-group mb-3">
                  <select class="form-control" v-model="bloodtest_temp_add.lipoProteinAUnit">
                    <option :value="''">Enhet för Lipoprotein (a)</option>
                    <option
                      v-for="(unit, i) in intervalLists.clinicMisc.lipoproteinRefList"
                      v-html="unit"
                      :key="i"
                      :title="toElementTitle(unit)">
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-4">
                <p class="text-dark pull-left"><strong>Referensintervall</strong></p>
                <div class="input-group mb-3">
                    <select class="form-control" v-model="bloodtest_temp_add.triglyceriderReferenceInterval">
                      <option :value="''">Välj intervall för Triglycerider</option>
                      <option
                        v-for="(t, i) in intervalLists.clinicMisc.triglyceriderRefList"
                        v-html="t"
                        :key="i"
                        :title="toElementTitle(t)">
                      </option>
                    </select>
                </div>
                <div class="input-group mb-3">
                    <select class="form-control" v-model="bloodtest_temp_add.totalKolesterolReferenceInterval">
                      <option :value="''">Välj intervall för Totalkolesterol</option>
                      <option
                        v-for="(tk, i) in intervalLists.clinicMisc.totalkolesterolRefList"
                        v-html="tk"
                        :key="i"
                        :title="toElementTitle(tk)">
                      </option>
                    </select>
                </div>
                <div class="input-group mb-3">
                    <select class="form-control" v-model="bloodtest_temp_add.hdlReferenceInterval">
                      <option :value="''">Välj intervall för HDL</option>
                      <option
                        v-for="(hdl, i) in intervalLists.clinicMisc.hdlRefList"
                        v-html="hdl"
                        :key="i"
                        :title="toElementTitle(hdl)">
                      </option>
                    </select>
                </div>
                <div class="input-group mb-1">&nbsp;</div>
                <div class="input-group mb-3">
                    <select class="form-control" v-model="bloodtest_temp_add.ldlReferenceInterval">
                      <option :value="''">Välj intervall för LDL</option>
                      <option
                        v-for="(ldl, i) in intervalLists.clinicMisc.ldlRefList"
                        v-html="ldl"
                        :key="i"
                        :title="toElementTitle(ldl)">
                      </option>
                    </select>
                </div>
                <div class="input-group mb-2">&nbsp;</div>
                <div class="input-group mb-3">
                    <select class="form-control" v-model="bloodtest_temp_add.ldlReferenceInterval">
                      <option :value="''">Välj intervall för LDL</option>
                      <option
                        v-for="(ldl, i) in intervalLists.clinicMisc.ldlRefList"
                        v-html="ldl"
                        :key="i"
                        :title="toElementTitle(ldl)">
                      </option>
                    </select>
                </div>
              </div>
            </div>
          </div>
          <div class="card journal-card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-7">
                  <div class="form-group">
                    <label v-html="data.clinicCardio.medicineHeaderCardio"></label>
                    <div v-for="(fhDrug, grouping) in fhDrugsArray" :key="grouping">
                      <p class="text-dark pull-left">
                        <strong>{{ fhDrug.grouping }}</strong>
                      </p>
                      <select class="form-control" v-model="fhDrug.value.selectedDrug" @change="fhDrug.value.selectedDosage = ''"
                      :disabled="noDrugs">
                        <option :value="''">Välj läkemedel</option>
                        <option
                          v-for="(drug, i) in fhDrug.value.drugsInGroup"
                          v-html="drug.drug"
                          :value="drug"
                          :key="i"
                          :title="toElementTitle(drug.drug)">
                        </option>
                      </select>
                      <select class="form-control" v-model="fhDrug.value.selectedDosage"
                      :disabled="fhDrug.value.selectedDrug == ''">
                        <option :value="''">Välj enhet</option>
                        <option
                            v-for="(dosages, i) in fhDrug.value.selectedDrug.dosages"
                          v-html="dosages.doseAmount + ' ' + dosages.doseUnit"
                          :value="dosages"
                          :key="i"
                          :title="toElementTitle(dosages.doseAmount + ' ' + dosages.doseUnit)">
                        </option>
                      </select>
                      <p class="text-dark pull-left" v-if="fhDrug.value.selectedDrug.frequency === 'day'">
                        <strong>Enhet avser en tablett per dag</strong>
                      </p>
                      <p class="text-dark pull-left" v-if="fhDrug.value.selectedDrug.frequency === 'byWeekly'">
                        <strong>Enhet avser en injection enligt fast dosinterval</strong>
                      </p>
                      <div class="clearfix"></div>
                    </div>
                    <label for="nodrugs">Patienten tar inga läkemedel:</label> &nbsp;
                    <input type="checkbox" @change="resetFhDrugs()" v-model="noDrugs" id="nodrugs">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-5">
                  <label class="left">Beräknad obehandlat LDL värde</label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text">LDL</span>
                    </div>
                    <input type="text" class="form-control"
                      v-model="bloodtest_temp_add.ldlUntreated" disabled>
                  </div>
                </div>
                <div class="col-sm-2">
                  <label class="left">&nbsp;</label>
                  <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="bloodtest_temp_add.ldlUnit" disabled>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-5">
                <button class="btn btn-primary" @click="sendBloodtest()"
                  :disabled="isEmptyObject(bloodtest_temp_add)">Spara provsvar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-success alert-bloodtest-add">
          <strong>Provsvar är tillagt samt sparat.</strong>
        </div>
        <div class="clearfix"></div>
        <!-- GET /bloodtestassessment --> <!-- POST /blodtestassessment -->
        <div class="card journal-card">
          <div class="card-body">
            <p class="text-dark pull-left"><strong>Bedömning av screeningfrågor och blodfettsnivåer</strong></p>
            <!-- Patientmallar -->
            <select class="form-control pull-right"
              v-if="isAssessmentTypePatient && patientTemplates"
              v-model="blood_template" @change="copyAssessmentTemplate()">
              <option :value="0">{{ chooseAssessmentTemplate }}</option>
              <option
                v-for="(cntnt, hdr) in patientTemplates.clinicMisc['patientTmpAssessmentGenNeg' + regionCode]"
                v-html="hdr"
                :value="cntnt"
                :key="cntnt"
                :title="toElementTitle(cntnt)">
              </option>
            </select>
            <!-- Journalmallar -->
            <select class="form-control pull-right"
              v-if="!isAssessmentTypePatient && journalTemplates"
              v-model="blood_template" @change="copyAssessmentTemplate()">
              <option :value="0">{{ chooseAssessmentTemplate }}</option>
              <option
                v-for="(cntnt, hdr) in journalTemplates.clinicMisc['journalTmpAssessmentGenNeg' + regionCode]"
                v-html="hdr"
                :value="cntnt"
                :key="hdr"
                :title="toElementTitle(cntnt)">
              </option>
            </select>
            <div class="row">
              <div class="col-sm-5 pull-left">
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="assessment"
                      v-model="assessment.bloodSampleAssessmentValue" value="6">
                       &nbsp; Normala värden
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="assessment"
                      v-model="assessment.bloodSampleAssessmentValue" value="7">
                       &nbsp; Förhöjda värden (videobesök ska bokas)
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="assessment"
                      v-model="assessment.bloodSampleAssessmentValue" value="8">
                       &nbsp; Gråzonsvärden (videobesök ska bokas)
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="assessment"
                      v-model="assessment.bloodSampleAssessmentValue" value="5">
                       &nbsp; Annat (inkl. misslyckad blodprovstagning)
                  </label>
                </div>
              </div>
              <div class="col-sm-7">
                <div class="form-group">
                  <label for="assessmentbloodtest">
                    <VueToggles
                      @click="isAssessmentTypePatient = !isAssessmentTypePatient"
                      :value="isAssessmentTypePatient"
                      height="30"
                      width="90"
                      checkedText="patient"
                      uncheckedText="journal"
                      checkedBg="#b4d455"
                      uncheckedBg="lightgrey"
                    />
                  </label>
                  <span v-if="assessment">
                    <textarea class="form-control" id="assessmentbloodtest" rows="6"
                      v-show="assessment && isAssessmentTypePatient" v-model="assessment.patientText"></textarea>
                    <textarea class="form-control" id="journalbloodtest" rows="6"
                      v-show="assessment && !isAssessmentTypePatient" v-model="journalNotes.journalText"></textarea>
                  </span>
                  <div class="clearfix--min"></div>
                  <br /><br />
                  <button
                  class="btn btn-btm width-50 btn-md btn-block btn-primary"
                  @click="sendBloodtestAssessment()"
                  v-if="assessment && isAssessmentTypePatient"
                  :disabled="!assessment.bloodSampleAssessmentValue || !assessment.patientText || !isAssessmentTypePatient">
                    Skicka till patient
                  </button>
                  <button
                  class="btn btn-btm width-25 btn-md btn-block btn-primary"
                  @click="saveAssessmentJournal(true)"
                  v-if="!isAssessmentTypePatient"
                  :disabled="isAssessmentTypePatient">
                    Spara vald journalmall
                  </button>
                  <p v-if="getAge < 13" class="p--minor-info">
                    Meddelandet går till vårdnadshavare eftersom patienten är under 13 år.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-success alert-assessment">
          <strong>Bedömningen är nu skickad.</strong>
        </div>
        <div class="clearfix"></div>
        <!-- GET /fhdiagnosis --> <!-- POST /fhdiagnosis -->
        <div class="card journal-card">
          <div class="card-body">
            <p class="text-dark pull-left"><strong>Beslut</strong></p>
            <!-- Patientmallar -->
            <select class="form-control pull-right"
              v-if="isDecisionTypePatient && patientTemplates"
              v-model="fh_template" @change="copyDecisionTemplate()">
              <option :value="0">{{ chooseDecisionTemplate }}</option>
              <option
                v-for="(cntnt, hdr) in patientTemplates.clinicMisc['patientTmpDecisionGenNeg' + regionCode]"
                v-html="hdr"
                :value="cntnt"
                :key="cntnt"
                :title="toElementTitle(cntnt)">
              </option>
            </select>
            <!-- Journalmallar -->
            <select class="form-control pull-right"
              v-if="!isDecisionTypePatient && journalTemplates"
              v-model="fh_template" @change="copyDecisionTemplate()">
              <option :value="0">{{ chooseDecisionTemplate }}</option>
              <option
                v-for="(cntnt, hdr) in journalTemplates.clinicMisc['journalTmpDecisionGenNeg' + regionCode]"
                v-html="hdr"
                :value="cntnt"
                :key="cntnt"
                :title="toElementTitle(cntnt)">
              </option>
            </select>
            <div class="row">
              <div class="col-sm-5 pull-left">
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="fhdiagnosis" v-model="fhdiagnosis.fhDiagnosisValue" value="1">
                    &nbsp; Bekräftad FH (vuxna och barn)
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="fhdiagnosis" v-model="fhdiagnosis.fhDiagnosisValue" value="3">
                    &nbsp; Avfärda FH (lipidvärden)
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="fhdiagnosis" v-model="fhdiagnosis.fhDiagnosisValue" value="8">
                    &nbsp; Avfärda FH (efter individuell bedömning)
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="fhdiagnosis" v-model="fhdiagnosis.fhDiagnosisValue" value="6">
                    &nbsp; Uppskjutet beslut (rekommendation om omkontroll)
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="fhdiagnosis" v-model="fhdiagnosis.fhDiagnosisValue" value="5">
                    &nbsp; Verifierad FH (diagnos sedan tidigare)
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="radio" v-if="fhdiagnosis" v-model="fhdiagnosis.fhDiagnosisValue" value="7">
                    &nbsp; Möjlig FH hos barn (remiss till barnläkare för bedömning)
                  </label>
                </div>
              </div>
              <div class="col-sm-7">
                <div class="form-group">
                  <label for="decision">
                    <VueToggles
                      @click="isDecisionTypePatient = !isDecisionTypePatient"
                      :value="isDecisionTypePatient"
                      height="30"
                      width="90"
                      checkedText="patient"
                      uncheckedText="journal"
                      checkedBg="#b4d455"
                      uncheckedBg="lightgrey"
                    />
                  </label>
                  <div v-if="!fhdiagnosis" class="div-loader">Laddar</div>
                  <span v-if="fhdiagnosis">
                    <textarea class="form-control" id="decision" rows="6"
                      v-show="fhdiagnosis && isDecisionTypePatient" v-model="fhdiagnosis.patientText"></textarea>
                    <textarea class="form-control" id="journalbloodtest" rows="6"
                      v-show="fhdiagnosis && !isDecisionTypePatient" v-model="journalNotes.journalTextDiagnosis"></textarea>
                  </span>
                  <div class="clearfix--min"></div>
                  <br /><br />
                  <button
                  class="btn btn-btm width-50 btn-md btn-block btn-primary"
                  @click="sendFHDiagnosis()"
                  v-if="fhdiagnosis && isDecisionTypePatient"
                  :disabled="!fhdiagnosis.fhDiagnosisValue || !fhdiagnosis.patientText || !isDecisionTypePatient">
                    Skicka till patient
                  </button>
                  <button
                  class="btn btn-btm width-25 btn-md btn-block btn-primary"
                  @click="saveAssessmentJournal(false)"
                  v-if="!isDecisionTypePatient"
                  :disabled="isDecisionTypePatient">
                    Spara vald journalmall
                  </button>
                  <p v-if="getAge < 13" class="p--minor-info">
                    Meddelandet går till vårdnadshavare eftersom patienten är under 13 år.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-success alert-diagnosis">
          <strong>Beslutet är nu skickat.</strong>
        </div>
        <div class="clearfix"></div>
        <!-- GET /referral/createhealthcenterreferral -->
        <!-- DELETE /referral/createhealthcenterreferral -->
        <div class="card journal-card">
          <div class="card-body">
            <p class="text-dark pull-left"><strong>Remiss för behandling</strong></p>
            <div class="row">
              <div class="col-sm-7">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text referral--input">
                      Vårdcentral:
                    </span>
                  </div>
                  <select class="form-control referral--select"
                    v-model="carefacility"
                    v-show="(carefacility !== enterHealthCenterManually) &&
                      (Object.keys(data.misc.facilitylist).includes(carefacility) || carefacility === '')">
                    <option :value="''">-- Ange vårdcentral --</option>
                    <option v-for="(region, facility) in data.misc.facilitylist" :value="facility" :key="facility">
                      {{ facility }}
                    </option>
                  </select>
                  <input type="text" class="form-control" :placeholder="enterHealthCenterManually"
                    v-model="carefacility" v-show="!Object.keys(data.misc.facilitylist).includes(carefacility)">
                  <div class="input-group-append">
                    <button class="btn btn-block btn-primary"
                    @click="sendHealthCenterReferral(false)">Spara</button>
                  </div>
                  <div class="input-group-append">
                    <button class="btn btn-block btn-danger"
                    :disabled="carefacility.length === 0"
                    @click="sendHealthCenterReferral(true)">Återställ</button>
                  </div>
                </div>
              </div>
              <div class="col-sm"></div>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-5">
                <span class="referral--span">Remiss till önskad vårdcentral skapad och skickad &nbsp;</span>
                <input
                  type="checkbox"
                  @change="healthCenterReferralStateChange($event)"
                  :checked="healthCenterReferral"
                  :disabled="!referral || (referral && !referral.healthCenter)"
                >
              </div>
              <div class="col-sm-4">
                <span class="referral--span">Videobesök genomfört &nbsp;</span>
                <input
                  type="checkbox"
                  @change="videoAppointmentCompletedStateChange($event)"
                  :checked="videoAppointmentCompleted"
                >
              </div>
            </div>
          </div>
        </div>
        <br />
        <!-- Kontakt angående vårdinrättning & rekvirera journalkopior -->
        <div class="card journal-card">
          <div class="card-body">
            <p class="text-dark pull-left"><strong>Journalkopior vid befintlig FH diagnos</strong></p>
            <div class="row">
              <div class="col-sm-4">
                Kontaktad angående sjukhus där diagnos fastställdes &nbsp;
                <input
                  type="checkbox"
                  @change="relativeContactedStateChange($event)"
                  :checked="relativeContacted"
                >
              </div>
              <div class="col-sm-2">
                Journalkopia rekvirerad &nbsp;
                <input
                  type="checkbox"
                  @change="orderMedicalRecordsStateChange($event)"
                  :checked="medicalRecordsOrdered"
                >
              </div>
              <div class="col-sm-4">
                Journalkopia mottagen &nbsp;
                <input
                  type="checkbox"
                  @change="receivedMedicalRecordsStateChange($event)"
                  :checked="medicalRecordsReceived"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-primary alert-bottom-right alert-idx">
          <strong>Valet är nu sparat.</strong>
        </div>
        <div class="clearfix"></div>
        <div class="row">
          <div class="col-sm-3">
            <button class="btn btn-primary btn-block" @click="confirmLeave()">Tillbaka</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../../config/index.js'
import axios from '../plugins/axios'
import $ from 'jquery'
import { getScreeningStatus } from '../plugins/screening_status'
import { request } from '../plugins/datocms'
import { inRange } from '../plugins/numberhelper'
import { friedewalds } from '../plugins/friedewalds'
import { fhDrugs } from '../plugins/fhdrugs'
import FieldId from '../plugins/fieldid'
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'

export default {
  name: 'patient_gen_negative',
  components: {
    DatePick
  },
  props: ['id'],
  data () {
    return {
      /* objects */
      data: null,
      patientTemplates: null,
      journalTemplates: null,
      intervalLists: null,
      patient: null,
      screeningAnswers: null,
      populationInfo: null,
      bloodtest: null,
      bloodtest_temp_add: {
        testDate: null,
        ldl: '',
        ldlFriedewalds: '',
        ldlUncalculated: '',
        ldlHighestMeasured: '',
        hdl: '',
        totalKolesterol: '',
        triglycerider: '',
        lipoProteinA: '',
        ldlUnit: 'mmol/L',
        hdlUnit: 'mmol/L',
        totalKolesterolUnit: 'mmol/L',
        triglyceriderUnit: 'mmol/L',
        lipoProteinAUnit: '',
        ldlReferenceInterval: '',
        hdlReferenceInterval: '',
        totalKolesterolReferenceInterval: '',
        triglyceriderReferenceInterval: ''
      },
      bloodtest_temp_edit: null,
      referral: null,
      paperReferral: null,
      healthCenterReferral: null,
      medicalRecordsOrdered: null,
      medicalRecordsReceived: null,
      videoAppointmentCompleted: null,
      relativeContacted: null,
      assessment: null,
      journalNotes: {
        journalText: null,
        journalDiagnosisText: null },
      fhdiagnosis: null,
      noDrugs: null,
      /* arrays */
      fhDrugTags: [],
      fhDrugsArray: fhDrugs,
      /* bools */
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa',
      hasPopulationInfo: Boolean,
      patientReady: false,
      showEditTestResults: false,
      isAssessmentTypePatient: true,
      isDecisionTypePatient: true,
      showAddTestResults: false,
      /* ints */
      blood_template: 0,
      fh_template: 0,
      /* strings */
      carefacility: '',
      templateClinician: localStorage.getItem('fullname') ? localStorage.getItem('fullname') : 'Läkare',
      clinic: localStorage.getItem('clinicName') ? localStorage.getItem('clinicName') : 'Medicinsk enhet Endokrinologi \n Karolinska universitetssjukhuset',
      regionCode: localStorage.getItem('regioncode'),
      chooseAssessmentTemplate: 'Välj patientmall (kopieras vid val)',
      chooseDecisionTemplate: 'Välj patientmall (kopieras vid val)',
      saveJournalMsg: '<strong>Mallen är nu sparad!</strong>',
      enterHealthCenterManually: 'Ange annan vårdcentral'
    }
  },
  methods: {
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    isEmptyObject (obj) {
      return Object.keys(obj).some(function (x) {
        // Exception for LDL(s) in bloodtest object because they are placeholders
        if (x === 'ldl' || x === 'ldlFriedewalds' || x === 'ldlUncalculated' || x === 'ldlUntreated' ||
          x === 'lipoProteinA' || x === 'lipoProteinAUnit' || x === 'ldlHighestMeasured') {
          return false
        }
        return obj[x] === '' || obj[x] === null
      })
    },
    isObjDirty (o) {
      return Object.keys(o || {}).some(function (x) {
        return o[x] === '' || o[x] === null || o[x] === 0 || typeof o[x] === 'undefined'
      })
    },
    isCharAllowed (e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^([0-9,-><]+)$/.test(char)) {
        return true
      } else {
        e.preventDefault()
      }
    },
    showAndScroll () {
      this.bloodtest_temp_edit = {
        testDate: this.bloodtest.testDate || null,
        ldl: this.bloodtest.ldl || '',
        ldlHighestMeasured: this.bloodtest.ldlHighestMeasured || '',
        ldlFriedewalds: this.bloodtest.ldlFriedewalds || '',
        ldlUntreated: this.bloodtest.ldlUntreated || '',
        ldlUncalculated: this.bloodtest.ldlUncalculated || '',
        hdl: this.bloodtest.hdl || '',
        totalKolesterol: this.bloodtest.totalKolesterol || '',
        triglycerider: this.bloodtest.triglycerider || '',
        lipoProteinA: this.bloodtest.lipoProteinA || '',
        ldlUnit: this.bloodtest.ldlUnit || 'mmol/L',
        hdlUnit: this.bloodtest.hdlUnit || 'mmol/L',
        totalKolesterolUnit: this.bloodtest.totalKolesterolUnit || 'mmol/L',
        triglyceriderUnit: this.bloodtest.triglyceriderUnit || 'mmol/L',
        lipoProteinAUnit: this.bloodtest.lipoProteinAUnit || '',
        ldlReferenceInterval: this.bloodtest.ldlReferenceInterval || '',
        hdlReferenceInterval: this.bloodtest.hdlReferenceInterval || '',
        totalKolesterolReferenceInterval: this.bloodtest.totalKolesterolReferenceInterval || '',
        triglyceriderReferenceInterval: this.bloodtest.triglyceriderReferenceInterval || ''
      }
      this.showEditTestResults = true
      this.showAddTestResults = false
      setTimeout(() => {
        const el = document.getElementById('edit-testresults')
        el.scrollIntoView({behavior: 'smooth', block: 'center'})
      }, 100)
    },
    goToBloodAssessmentCard () {
      const card = document.getElementById('bloodtestassessment-card')
      card.scrollIntoView({behavior: 'smooth', block: 'center'})
    },
    toElementTitle (str) {
      if (str) {
        let res = $('<textarea />').html(str).text() // convert special html entity chars
        res = res.replace(/<[^>]*>?/gm, '') // strip html tags
        return res
      }
    },
    copyAssessmentTemplate () {
      let bloodTemplate = ''
      if (this.blood_template !== 0) {
        bloodTemplate = this.blood_template
      }
      if (this.isAssessmentTypePatient) {
        this.assessment.patientText = ''
        this.assessment.patientText = bloodTemplate +
          '\n\n' + this.templateClinician + '\n' + this.clinic
      } else {
        this.journalNotes.journalText = bloodTemplate
          .split('Bedömning').join('\n\n Bedömning')
          .split('Åtgärd').join('\n Åtgärd')
          .split('Diagnos').join('\n Diagnos')
          .split('Tilläggskod').join('\n Tilläggskod')
      }
    },
    copyDecisionTemplate () {
      let fhTemplate = ''
      if (this.fh_template !== 0) {
        fhTemplate = this.fh_template
      }
      if (this.isDecisionTypePatient) {
        this.fhdiagnosis.patientText = ''
        this.fhdiagnosis.patientText = fhTemplate +
          '\n\n' + this.templateClinician + '\n' + this.clinic
      } else {
        this.journalNotes.journalTextDiagnosis = fhTemplate
          .split('Bedömning').join('\n\n Bedömning')
          .split('Åtgärd').join('\n Åtgärd')
          .split('Diagnos').join('\n Diagnos')
          .split('Tilläggskod').join('\n Tilläggskod')
      }
    },
    saveAssessmentJournal (isBlood) {
      let loader = this.$loading.show()
      const journalNote = {
        personId: this.assessment.personId,
        journalText: isBlood ? this.journalNotes.journalText : null,
        journalTextDiagnosis: isBlood ? null : this.journalNotes.journalTextDiagnosis
      }
      axios.postJournalNote(config.journalNoteUri, journalNote).then(response => {
        if (response) {
          $('.alert-assessment').html(this.saveJournalMsg).show().delay(4000).fadeOut()
          setTimeout(() => {
            loader.hide()
          }, 1000)
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not save journal note: ' + error)
          loader.hide()
        }
      })
    },
    getStatus (status) {
      return getScreeningStatus(status)
    },
    getFieldId (lbl) {
      return FieldId(lbl)
    },
    formatPnr (ssn) {
      if (ssn) {
        const pnr = ssn.substring(0, 4) + '-' +
                      ssn.substring(4, 6) + '-' +
                      ssn.substring(6, 8) + '-' +
                      ssn.substring(8, 12)
        return pnr
      }
      return '-'
    },
    prePopulateReferenceIntervals (age, gender) {
      if (inRange(age, 0, 1)) {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[0]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[0]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[0]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[0]
      } else if (inRange(age, 1, 14)) {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[0]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[1]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[1]
      } else if (inRange(age, 14, 17) && gender === 'Kvinna') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[1]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[1]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[2]
      } else if (inRange(age, 14, 17) && gender === 'Man') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[2]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[1]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[3]
      } else if (inRange(age, 18, 30) && gender === 'Kvinna') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[2]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[3]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[4]
      } else if (inRange(age, 18, 30) && gender === 'Man') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[2]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[4]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[4]
      } else if (inRange(age, 31, 50) && gender === 'Kvinna') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[3]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[3]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[5]
      } else if (inRange(age, 31, 50) && gender === 'Man') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[3]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[4]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[5]
      } else if (inRange(age, 51, 120) && gender === 'Kvinna') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[4]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[3]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[6]
      } else if (inRange(age, 51, 120) && gender === 'Man') {
        this.bloodtest_temp_add.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[4]
        this.bloodtest_temp_add.hdlReferenceInterval = this.intervalLists.clinicMisc.hdlRefList[4]
        this.bloodtest_temp_add.triglyceriderReferenceInterval = this.intervalLists.clinicMisc.triglyceriderRefList[2]
        this.bloodtest_temp_add.totalKolesterolReferenceInterval = this.intervalLists.clinicMisc.totalkolesterolRefList[6]
      }
    },
    showAddAndScroll () {
      this.prePopulateReferenceIntervals(this.getAge, this.getGender)
      this.showAddTestResults = true
      this.showEditTestResults = false
      setTimeout(() => {
        const el = document.getElementById('add-testresults')
        el.scrollIntoView({behavior: 'smooth', block: 'center'})
      }, 100)
    },
    inviteIdx () {
      sessionStorage.setItem('patientToBeConverted', JSON.stringify({ type: 'screening', id: this.$props.id }))
      this.$router.push({
        name: 'createnewidx',
        params: { patientType: 1 }
      })
    },
    discloseIdx () {
      const r = confirm('Är du säker på detta?')
      if (r) {
        axios._patch(config.familytreeUri + '/byId?PersonId=' + this.$props.id).then(res => {
          if (res) {
            $('.alert-idx').show().delay(4000).fadeOut()
            setTimeout(() => {
              this.$router.go()
            }, 3000)
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not disclose patient: ' + error)
          }
        })
      }
    },
    endPatientParticipation () {
      const r = confirm('Är du säker på detta?')
      if (r) {
        axios._delete(config.familytreeUri + '/byId?PersonId=' + this.$props.id).then(res => {
          if (res) {
            $('.alert-idx').show().delay(4000).fadeOut()
            setTimeout(() => {
              this.$router.go()
            }, 3000)
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not end patient participation: ' + error)
          }
        })
      }
    },
    async getPatientById () {
      let loader = this.$loading.show()
      axios._get(config.familytreeUri + '/byId?PersonId=' + this.$props.id).then(response => {
        this.patient = response.data.relativeData
        this.patientReady = true
        this.getFromNavet()
        loader.hide()
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get patient by id ' + this.$props.id + ', Error: ' + error)
          loader.hide()
        }
      })
    },
    async getScreeningAnswers () {
      axios._get(config.screeninganswerUri + '?PersonId=' + this.$props.id).then(response => {
        this.screeningAnswers = response.data.answers
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get screeninganswers: ' + error)
        }
      })
    },
    async getBloodTest () {
      axios._get(config.bloodtestUri + '?PersonId=' + this.$props.id).then(response => {
        this.bloodtest = response.data.bloodTest
        if (this.bloodtest) {
          try {
            const ldl = JSON.parse(this.bloodtest.ldl)
            this.bloodtest.ldlHighestMeasured = ldl.ldlHighestMeasured.replace(/,/g, '.')
            this.bloodtest.ldlFriedewalds = ldl.ldlFriedewalds.replace(/,/g, '.')
            this.bloodtest.ldlUntreated = ldl.ldlUntreated.replace(/,/g, '.')
            this.bloodtest.ldlUncalculated = ldl.ldlUncalculated.replace(/,/g, '.')
          } catch (msg) {
            console.log('Could not parse bloodtest LDL, assigning value directly.')
            this.bloodtest.ldlUncalculated = this.bloodtest.ldl
          }
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get bloodtest: ' + error)
        }
      })
    },
    async getJournalNotes () {
      axios._get(config.journalNoteUri + '/' + this.$props.id).then(response => {
        if (response && response.data && response.data.journalNote && response.data.journalNote.journalText) {
          this.journalNotes = response.data.journalNote
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get journal notes: ' + error)
        }
      })
    },
    async getBloodTestAssessment () {
      axios._get(config.bloodtestAssessmentUri + '?PersonId=' + this.$props.id).then(response => {
        this.assessment = response.data.assessment
        if (this.assessment) {
          this.assessment.type = 'patient'
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get assessment for bloodtest: ' + error)
        }
      })
    },
    async getFHDiagnosis () {
      axios._get(config.fhdiagnosisUri + '?PersonId=' + this.$props.id).then(response => {
        this.fhdiagnosis = response.data.fhDiagnosis
        if (this.fhdiagnosis) {
          this.fhdiagnosis.type = 'patient'
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get FH diagnosis: ' + error)
        }
      })
    },
    async getReferralHealthcenter () {
      axios._get(config.referralUri + config.healthCenterReferralUri + '?PersonId=' + this.$props.id).then(response => {
        this.referral = response.data.referral
        if (this.referral) {
          this.carefacility = this.referral.healthCenter
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get healthcenter for referral: ' + error)
        }
      })
    },
    async getCreateHealthCenterReferral () {
      axios._get(config.referralUri + config.createHealthcenterReferralUri + '?PersonId=' + this.$props.id).then(response => {
        this.healthCenterReferral = response.data.paperReferralExists
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get healthcenter for referral: ' + error)
        }
      })
    },
    async getVideoAppointmentCompleted () {
      axios._get(config.referralUri + config.videoAppointmentCompletedUri + '?PersonId=' + this.$props.id).then(response => {
        this.videoAppointmentCompleted = response.data.result
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get video appointment status: ' + error)
        }
      })
    },
    async getPaperReferral () {
      axios._get(config.referralUri + config.createPaperReferralUri + '?PersonId=' + this.$props.id).then(response => {
        this.paperReferral = response.data.paperReferralExists
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get healthcenter for referral: ' + error)
        }
      })
    },
    async getOrderMedicalRecords () {
      axios._get(config.medicalRecordsUri + config.orderMedicalRecordsUri + '?PersonId=' + this.$props.id).then(response => {
        this.medicalRecordsOrdered = response.data.orderMedicalRecordsExists
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get if medical record is requisitioned: ' + error)
        }
      })
    },
    async getReceivedMedicalRecords () {
      axios._get(config.medicalRecordsUri + config.receivedMedicalRecordsUri + config.geneNegativeUri +
        '?PersonId=' + this.$props.id).then(response => {
        this.medicalRecordsReceived = response.data.medicalRecordsReceivedExists
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get if medical record is received: ' + error)
        }
      })
    },
    async getRelativeContactedStatus () {
      axios._get(config.medicalRecordsUri + config.relativeContactedUri + '?PersonId=' + this.$props.id).then(response => {
        this.relativeContacted = response.data.relativeContactedExists
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get if relative is contacted: ' + error)
        }
      })
    },
    getFromNavet () {
      axios.postPopulationRegistry(config.populationRegistryUri, this.patient.ssn).then((response) => {
        if (response) {
          this.populationInfo = response.data
          if (this.populationInfo) {
            this.hasPopulationInfo = true
          }
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log(error)
        }
      })
    },
    getSpecificScreeningAnswer (fieldId) {
      if (this.screeningAnswers && this.screeningAnswers.length > 0) {
        for (let index = 0; index < this.screeningAnswers.length; index++) {
          const screeningAnswer = this.screeningAnswers[index]
          if (screeningAnswer.fieldId === fieldId) {
            const answer = JSON.parse(screeningAnswer.answer)
            return answer
          }
        }
      } else {
        return null
      }
    },
    sendUpdatedTestResults () {
      const r = confirm('Är du säker på att du vill uppdatera provsvaren?')
      if (r) {
        let loader = this.$loading.show()
        this.bloodtest_temp_edit.personId = parseInt(this.$props.id)
        this.bloodtest_temp_edit.ldl = JSON.stringify({
          ldlHighestMeasured: this.bloodtest_temp_edit.ldlHighestMeasured,
          ldlFriedewalds: this.bloodtest_temp_edit.ldlFriedewalds,
          ldlUntreated: this.bloodtest_temp_edit.ldlUntreated,
          ldlUncalculated: this.bloodtest_temp_edit.ldlUncalculated
        })
        axios.putBloodTest(config.bloodtestUri, this.bloodtest_temp_edit).then(response => {
          if (response) {
            this.showEditTestResults = false
            $('.alert-bloodtest-edit').show().delay(4000).fadeOut()
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not update bloodtest results: ' + error)
            loader.hide()
          }
        })
      }
    },
    sendBloodtest () {
      const r = confirm('Är du säker på att du vill lägga till provsvar?')
      if (r) {
        let loader = this.$loading.show()
        this.bloodtest_temp_add.personId = parseInt(this.$props.id)
        this.bloodtest_temp_add.ldl = JSON.stringify({
          ldlHighestMeasured: this.bloodtest_temp_add.ldlHighestMeasured,
          ldlFriedewalds: this.bloodtest_temp_add.ldlFriedewalds,
          ldlUntreated: this.bloodtest_temp_add.ldlUntreated,
          ldlUncalculated: this.bloodtest_temp_add.ldlUncalculated
        })
        axios.postBloodTest(config.bloodtestUri, this.bloodtest_temp_add).then(response => {
          if (response) {
            this.showAddTestResults = false
            $('.alert-bloodtest-add').show().delay(4000).fadeOut()
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not send bloodtest: ' + error)
            loader.hide()
          }
        })
      }
    },
    sendBloodtestAssessment () {
      const r = confirm('Är du säker på detta?')
      if (r) {
        let loader = this.$loading.show()
        const assessment = {
          pid: this.assessment.personId,
          btaValue: parseInt(this.assessment.bloodSampleAssessmentValue),
          patientText: this.assessment.patientText
        }
        axios.postBloodTestAssessment(config.bloodtestAssessmentUri + config.geneNegativeUri, assessment).then(response => {
          if (response) {
            $('.alert-assessment').show().delay(4000).fadeOut()
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not send gene negative bloodtest assessment: ' + error)
            loader.hide()
          }
        })
      }
    },
    sendFHDiagnosis () {
      const r = confirm('Är du säker på detta?')
      if (r) {
        let loader = this.$loading.show()
        const diagnosis = {
          pid: this.fhdiagnosis.personId,
          fhValue: parseInt(this.fhdiagnosis.fhDiagnosisValue),
          patientText: this.fhdiagnosis.patientText,
          clinicianId: this.patient.clinicianId
        }
        axios.postFhDiagnosis(config.fhdiagnosisUri + config.geneNegativeUri, diagnosis).then(response => {
          if (response) {
            $('.alert-diagnosis').show().delay(4000).fadeOut()
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not send gene negative fh diagnosis: ' + error)
            loader.hide()
          }
        })
      }
    },
    sendHealthCenterReferral (restore) {
      const r = confirm('Är du säker på detta?')
      if (r) {
        let loader = this.$loading.show()
        const labId = ''
        if (restore) {
          this.carefacility = ''
        }
        axios.postHealthCenterReferral(
          config.referralUri + config.healthCenterReferralUri,
          parseInt(this.$props.id), labId, this.carefacility
        ).then(response => {
          setTimeout(() => {
            loader.hide()
            this.$router.go()
          }, 2000)
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not set health center for referral: ' + error)
            loader.hide()
          }
        })
      }
    },
    videoAppointmentCompletedStateChange (event) {
      const checked = event.target.checked
      const r = confirm('Är du säker på detta?')
      if (r) {
        let loader = this.$loading.show()
        const req = config.referralUri + config.videoAppointmentCompletedUri + '?PersonId=' + this.$props.id
        if (checked) {
          axios._post(req).then(response => {
            this.videoAppointmentCompleted = true
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not set videoappointment completed: ' + error)
              loader.hide()
            }
          })
        } else {
          axios._delete(req).then(response => {
            this.videoAppointmentCompleted = false
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not delete videoappointment completed: ' + error)
              loader.hide()
            }
          })
        }
      } else {
        $(event.target).prop('checked', false)
      }
    },
    healthCenterReferralStateChange (event) {
      const checked = event.target.checked
      const r = confirm('Är du säker på detta?')
      if (r) {
        let loader = this.$loading.show()
        const req = config.referralUri + config.createHealthcenterReferralUri + '?PersonId=' + this.$props.id
        if (checked) {
          axios._post(req).then(response => {
            this.healthCenterReferral = true
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not set healthcenter referral: ' + error)
              loader.hide()
            }
          })
        } else {
          axios._delete(req).then(response => {
            this.healthCenterReferral = false
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not delete healthcenter referral: ' + error)
              loader.hide()
            }
          })
        }
      } else {
        $(event.target).prop('checked', false)
      }
    },
    paperReferralStateChange (event) {
      const checked = event.target.checked
      const r = confirm('Är du säker på detta?')
      if (r) {
        let loader = this.$loading.show()
        const req = config.referralUri + config.createPaperReferralUri + '?PersonId=' + this.$props.id
        if (checked) {
          axios._post(req).then(response => {
            this.paperReferral = true
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not set paper referral: ' + error)
              loader.hide()
            }
          })
        } else {
          axios._delete(req).then(response => {
            this.paperReferral = false
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not delete paper referral: ' + error)
              loader.hide()
            }
          })
        }
      } else {
        $(event.target).prop('checked', false)
      }
    },
    orderMedicalRecordsStateChange (event) {
      const checked = event.target.checked
      const r = confirm('Är du säker på detta?')
      if (r) {
        let loader = this.$loading.show()
        const req = config.medicalRecordsUri + config.orderMedicalRecordsUri + '?PersonId=' + this.$props.id
        if (checked) {
          axios._post(req).then(response => {
            this.medicalRecordsOrdered = true
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not set medical records order status: ' + error)
              loader.hide()
            }
          })
        } else {
          axios._delete(req).then(response => {
            this.medicalRecordsOrdered = false
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not delete medical records order status: ' + error)
              loader.hide()
            }
          })
        }
      } else {
        $(event.target).prop('checked', false)
      }
    },
    receivedMedicalRecordsStateChange (event) {
      const checked = event.target.checked
      const r = confirm('Är du säker på detta?')
      if (r) {
        let loader = this.$loading.show()
        const req = config.medicalRecordsUri + config.receivedMedicalRecordsUri + config.geneNegativeUri +
          '?PersonId=' + this.$props.id
        if (checked) {
          axios._post(req).then(response => {
            this.medicalRecordsReceived = true
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not set medical records receival: ' + error)
              loader.hide()
            }
          })
        } else {
          axios._delete(req).then(response => {
            this.medicalRecordsReceived = false
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not delete medical records receival: ' + error)
              loader.hide()
            }
          })
        }
      } else {
        $(event.target).prop('checked', false)
      }
    },
    relativeContactedStateChange (event) {
      const checked = event.target.checked
      const r = confirm('Är du säker på detta?')
      if (r) {
        let loader = this.$loading.show()
        const req = config.medicalRecordsUri + config.relativeContactedUri + '?PersonId=' + this.$props.id
        if (checked) {
          axios._post(req).then(response => {
            this.relativeContacted = true
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not set relative contacted status: ' + error)
              loader.hide()
            }
          })
        } else {
          axios._delete(req).then(response => {
            this.relativeContacted = false
            setTimeout(() => {
              loader.hide()
              this.$router.go()
            }, 2000)
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not delete relative contacted status: ' + error)
              loader.hide()
            }
          })
        }
      } else {
        $(event.target).prop('checked', false)
      }
    },
    calculateUntreatedLDL () {
      // Select ldl to calculate
      let ldlToCalculate = ''
      if (this.showAddTestResults) {
        if (this.bloodtest_temp_add.ldlFriedewalds !== '') {
          ldlToCalculate = this.bloodtest_temp_add.ldlFriedewalds
        } else if (this.bloodtest_temp_add.ldlUncalculated !== '') {
          ldlToCalculate = this.bloodtest_temp_add.ldlUncalculated
        }
      } else if (this.showEditTestResults) {
        if (this.bloodtest_temp_edit.ldlFriedewalds !== '') {
          ldlToCalculate = this.bloodtest_temp_edit.ldlFriedewalds
        } else if (this.bloodtest_temp_edit.ldlUncalculated !== '') {
          ldlToCalculate = this.bloodtest_temp_edit.ldlUncalculated
        }
      } else {
        ldlToCalculate = ''
      }

      // Calculate ldl
      if (ldlToCalculate && ldlToCalculate.toString().length > 0) {
        let calculatedLDL = ldlToCalculate.replace(/,/g, '.')
        this.fhDrugsArray.forEach(fhd => {
          if (fhd.value['selectedDosage']) {
            calculatedLDL *= fhd.value['selectedDosage'].correctionFactor
          }
        })
        if (calculatedLDL && calculatedLDL.toString().length > 0) {
          calculatedLDL = parseFloat(calculatedLDL).toFixed(2)
          if (this.showAddTestResults) {
            this.bloodtest_temp_add.ldlUntreated = calculatedLDL
          } else if (this.showEditTestResults) {
            this.bloodtest_temp_edit.ldlUntreated = calculatedLDL
          }
        }
      } else {
        if (this.showAddTestResults) {
          this.bloodtest_temp_add.ldlUntreated = ''
        } else if (this.showEditTestResults) {
          this.bloodtest_temp_edit.ldlUntreated = ''
        }
      }
    },
    resetFhDrugs () {
      this.fhDrugsArray.forEach(fhd => {
        fhd.value['selectedDrug'] = ''
        fhd.value['selectedDosage'] = ''
      })
    },
    /* not in use */
    validateFhDrugs () {
      let hasSelectedDrug = false
      let hasError = false
      this.fhDrugsArray.forEach(fhd => {
        if (fhd.value['selectedDrug'] !== '' && fhd.value['selectedDosage'] !== '') {
          hasSelectedDrug = true
        } else if ((fhd.value['selectedDrug'] && fhd.value['selectedDosage'] === '') ||
          (fhd.value['selectedDrug'] === '' && fhd.value['selectedDosage'])) {
          hasError = true
        }
      })
      return hasSelectedDrug && !hasError
    },
    confirmLeave () {
      const r = confirm('Är du säker? Du kan ha osparade ändringar.')
      if (r) {
        this.$router.go(-1)
      }
    }
  },
  watch: {
    bloodtest_temp_add: {
      handler (bt) {
        if (bt.hdl.length > 0 && bt.totalKolesterol.length > 0 && (bt.triglycerider.length > 0 && bt.triglycerider.replace(/,/g, '.') < 4.5)) {
          this.bloodtest_temp_add.ldlFriedewalds = friedewalds(
            bt.totalKolesterol.replace(/,/g, '.'), bt.hdl.replace(/,/g, '.'), bt.triglycerider.replace(/,/g, '.')
          )
          this.bloodtest_temp_add.ldlUncalculated = ''
        } else {
          this.bloodtest_temp_add.ldlFriedewalds = ''
        }
        this.calculateUntreatedLDL()
      },
      deep: true
    },
    bloodtest_temp_edit: {
      handler (bt) {
        if (bt.hdl.length > 0 && bt.totalKolesterol.length > 0 && (bt.triglycerider.length > 0 && bt.triglycerider.replace(/,/g, '.') < 4.5)) {
          this.bloodtest_temp_edit.ldlFriedewalds = friedewalds(
            bt.totalKolesterol.replace(/,/g, '.'), bt.hdl.replace(/,/g, '.'), bt.triglycerider.replace(/,/g, '.')
          )
          this.bloodtest_temp_edit.ldlUncalculated = ''
        } else {
          this.bloodtest_temp_edit.ldlFriedewalds = ''
        }
        this.calculateUntreatedLDL()
      },
      deep: true
    },
    fhDrugsArray: {
      handler (fhd) {
        this.calculateUntreatedLDL()
      },
      deep: true
    },
    drugs: {
      handler (d) {
        if (d && d.length > 0) {
          this.noDrugs = null
        }
      },
      deep: true
    },
    noDrugs (nd) {
      if (nd === false) {
        this.noDrugs = null
      }
    },
    isAssessmentTypePatient (state) {
      if (state) {
        this.blood_template = 0
        this.chooseAssessmentTemplate = 'Välj patientmall (kopieras vid val)'
      } else {
        this.assessment.type = 'journal'
        this.chooseAssessmentTemplate = 'Välj journalmall (kopieras vid val)'
        this.blood_template = 0
      }
    },
    isDecisionTypePatient (state) {
      if (state) {
        this.fh_template = 0
        this.chooseAssessmentTemplate = 'Välj patientmall (kopieras vid val)'
      } else {
        this.assessment.type = 'journal'
        this.chooseAssessmentTemplate = 'Välj journalmall (kopieras vid val)'
        this.fh_template = 0
      }
    }
  },
  computed: {
    getAge () {
      if (this.patient) {
        const today = new Date()
        const birthDate = new Date(this.patient.ssn.substring(0, 4) +
          '/' + this.patient.ssn.substring(4, 6) + '/' + this.patient.ssn.substring(6, 8))
        let age = today.getFullYear() - birthDate.getFullYear()
        const m = today.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }
        return age
      }
    },
    getGender () {
      if (this.patient) {
        const n = parseInt(this.patient.ssn.charAt(10))
        if (n % 2 === 0) { // Even Number
          return 'Kvinna'
        }
        return 'Man'
      }
    },
    consentJournalsText () {
      if (this.getSpecificScreeningAnswer(this.getFieldId('consentjournals'))) {
        return 'Godkänner du att vi tar del av dina journaluppgifter via Nationell patientöversikt (NPÖ) för att ta söka upp denna information?'
      }
    }
  },
  async beforeMount () {
    await this.getPatientById()
    await this.getScreeningAnswers()
    await this.getBloodTest()
    await this.getJournalNotes()
    await this.getBloodTestAssessment()
    await this.getFHDiagnosis()
    await this.getReferralHealthcenter()
    await this.getCreateHealthCenterReferral()
    await this.getPaperReferral()
    await this.getVideoAppointmentCompleted()
    await this.getOrderMedicalRecords()
    await this.getReceivedMedicalRecords()
    await this.getRelativeContactedStatus()
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          clinicInfoIcon {
            triglyceridesTooHigh
          }
          clinicCardio {
            medicineHeaderCardio
          }
          misc {
            facilitylist
          }
        }
      `
    })
    this.patientTemplates = await request({
      query: `
        {
          clinicMisc {
            patientTmpAssessmentGenNeg` + this.regionCode + `
            patientTmpDecisionGenNeg` + this.regionCode + `
          }
        }
      `
    })
    this.journalTemplates = await request({
      query: `
        {
          clinicMisc {
            journalTmpAssessmentGenNeg` + this.regionCode + `
            journalTmpDecisionGenNeg` + this.regionCode + `
          }
        }
      `
    })
    this.intervalLists = await request({
      query: `
        {
          clinicMisc {
            ldlRefList
            hdlRefList
            triglyceriderRefList
            totalkolesterolRefList
            lipoproteinRefList
          }
        }
      `
    })
  },
  beforeRouteLeave (to, from, next) {
    if (to.path.includes('indexpatient_gen_negative/')) {
      next()
    } else {
      const parts = to.path.split('/')
      const uri = '/' + parts[parts.length - 1]
      window.location.href = window.location.origin + uri
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
::-webkit-input-placeholder {
  opacity: 0.6;
}
::-moz-placeholder {
  opacity: 0.6;
}
:-ms-input-placeholder {
  opacity: 0.6;
}
:-moz-placeholder {
  opacity: 0.6;
}
input[type=checkbox] {
  transform: scale(1.5);
}
button:disabled {
  opacity: 0.3;
}
.disable-edit {
  opacity: 0.3;
  pointer-events: none;
}
.img--zoom {
  transform: scale(1.2);
}
.min-w-275 {
  min-width: 275px;
}
.width-50 {
  width: 50%;
}
.width-25 {
  width: 25%;
}
.container > * {
  text-align: left;
}
.icon {
  line-height: 33px;
  margin-right: 8px;
}
.modal-title {
  padding: 10px;
  margin-left: 5px;
}
.btn-btm {
  bottom: 1vw;
  position: absolute;
  max-width: 94%;
}
.table {
  max-width: none;
  table-layout: fixed;
  word-wrap: break-word;
}
.left {
  float: left !important;
}
.right {
  float: right !important;
}
.pull-left {
  text-align: left;
}
.pull-right {
  margin: 15px;
  top: 0;
  right: 0;
  position: absolute;
}
.col-mr-60 {
  margin-right: 60px;
}
.light-red, .light-red:hover {
  background: #FCF2EB !important;
}
.light-yellow, .light-yellow:hover {
  background: #FEFFF3 !important;
}
.journal-card:hover {
  background: #f8e9b8;
  border: 1px solid #efe4c2;
  color: #000;
  opacity: 1.0;
}
.journal-card {
  background: #fff8e2;
  border: 1px solid #F7ECC9;
  color: #38362E;
  opacity: 0.8;
}
#referral--input {
  display: none;
}
.referral--input {
  background: none !important;
  border: 0 !important;
}
.referral--select {
  border-top-left-radius: .25rem !important;
  border-bottom-left-radius: .25rem !important;
  height: auto !important;
}
.referral--span {
  line-height: 35px;
}
.card-body > select {
  width: 20%;
}
.top-right-close {
  cursor: pointer !important;
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 30px;
  margin-right: 0.5em;
}
.top-right {
  position: absolute;
  top: 0px;
  right: 0px;
  margin-top: 6.5em;
  margin-right: 2em;
}
.p--minor-info {
  position: absolute;
  text-decoration: underline;
  font-size: 12px;
  bottom: 25px;
  right: 20px;
}
.card-screening hr {
  margin-top: 5px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/PatientGenNegative.vue